<template>
  <v-main class="page-form-main-instruction">
    <portal to="app-bar">
      <v-app-bar
        app
        color="secondary"
        dark
      >
        <v-btn
          icon
          @click="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title>{{ $t('form.show.testing-table') }}</v-toolbar-title>
      </v-app-bar>
    </portal>

    <v-container>
      <v-row>
        <v-col cols="12">
          <div
            v-for="el of project.formMain"
            v-if="isVisible(el)"
            :id="`el-${el.id}`"
            :key="el.id"
            class="entry"
          >
            <FormLabel
              v-if="['page_break', 'text', 'image_display'].indexOf(el.type) === -1"
              :required="el.options.required"
              :title="el.options.title"
              :filled="isFieldValid(el)"
              :field-type="el.type"
              check
            />
            <FormElementView
              :value="data[el.id]"
              :type="el.type"
              v-bind="el"
            />
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-footer
      v-if="!projectData.sentAt"
      app
    >
      <v-row>
        <v-col>
          <v-btn
            :disabled="!isValid"
            color="primary"
            block
            large
            @click="sendForm"
          >
            {{ $t('misc.send') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>
  </v-main>
</template>

<script>
import IsEqual from 'lodash.isequal';
import FormLabel from '@/components/FormLabel';
import FormElementView from '@/components/FormElementView';
import { checkConditions, checkFormValid, checkFieldValid } from '@/lib/validation';

export default {
  components: {
    FormLabel,
    FormElementView
  },
  props: {
    project: { type: Object, required: true },
    projectData: { type: Object, required: true }
  },
  computed: {
    data () {
      return this.projectData.data || {};
    },
    isValid () {
      return checkFormValid(this.project.formMain, this.data);
    }
  },
  methods: {
    isFieldValid(el) {
      return checkFieldValid(this.project.formMain, this.data, el);
    },
    isVisible(el) {
      if (!el.visibility) {
        return true;
      }

      let link = 'and';
      if (el.vLink) {
        link = el.vLink;
      }

      return checkConditions(el.visibility, link, this.data);
    },
    async sendForm () {
      const data = await this.$pouch.get(this.projectData._id, {}, 'project_data');
      data.sentAt = true;
      data.synced = false;
      await this.$pouch.put(data, { force: true }, 'project_data');

      this.$router.push({ name: 'home' });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-element-viewer {
  margin-bottom: 12px;
}
</style>
